import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import api from '../lib/api';
import { toast } from 'sonner';

export const useSavedJobs = (profile) => {
  const [savedJobIds, setSavedJobIds] = useState([]);
  const [loading, setLoading] = useState(false);

  const isSeeker = profile?.role === 'job_seeker' || profile?.role === 'seeker';

  useEffect(() => {
    if (profile?.id && isSeeker) {
      fetchSavedJobIds();
    }
  }, [profile?.id, isSeeker]);

  const fetchSavedJobIds = async () => {
    if (!profile?.id || !isSeeker) return;

    try {
      const { data } = await supabase
        .from('saved_jobs')
        .select('job_id')
        .eq('user_id', profile.id);

      if (data) {
        setSavedJobIds(data.map(item => item.job_id));
      }
    } catch (error) {
      console.error('Error fetching saved jobs:', error);
    }
  };

  const toggleSaveJob = async (jobId) => {
    if (!isSeeker) {
      toast.error('Only job seekers can save jobs');
      return;
    }

    setLoading(true);
    try {
      const { data: session } = await supabase.auth.getSession();
      if (!session?.session?.access_token) {
        toast.error('Please log in');
        return;
      }

      const isSaved = savedJobIds.includes(jobId);

      if (isSaved) {
        // Unsave
        await api.delete(`/api/jobs/${jobId}/save`, {
          headers: { Authorization: `Bearer ${session.session.access_token}` }
        });
        setSavedJobIds(prev => prev.filter(id => id !== jobId));
        toast.success('Job removed from saved');
      } else {
        // Save
        await api.post(`/api/jobs/${jobId}/save`, {}, {
          headers: { Authorization: `Bearer ${session.session.access_token}` }
        });
        setSavedJobIds(prev => [...prev, jobId]);
        toast.success('Job saved!');
      }
    } catch (error) {
      console.error('Toggle save error:', error);
      toast.error(error.response?.data?.detail || 'Failed to save job');
    } finally {
      setLoading(false);
    }
  };

  const refetch = fetchSavedJobIds;

  return { savedJobIds, toggleSaveJob, loading, refetch };
};
